import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import {
  Box,
  Typography
} from '@material-ui/core';

import { fetchSavedSearches, selectSavedSearchesByOwner, deleteSearch } from './itemSearchesSlice';
import { setActiveSearch } from './itemSearchSlice';
import ItemSearchesList from './itemSearchesList';

import Loading from '../common/loading';
import Alert from '../common/alert';
import TopSection from '../common/topSection';
import useTitle from '../../hooks/use-title.hook';

const SavedSearches = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { searches, status, error } =  useSelector(selectSavedSearchesByOwner);

  useEffect(() => {
    // Fetch all from server
    if(status === 'idle') {
      dispatch(fetchSavedSearches());
    }
  }, [dispatch, status]);

  useTitle(t('itemSearch:savedSearches'));

  const handleDelete = searchId => {
    dispatch(deleteSearch(searchId));
  };

  const handleSelect = searchObj => {
    dispatch(setActiveSearch(searchObj));
    history.push(`/pih/owner/${searchObj.itemOwner}/items`);
  }

  return (
    <>
      <TopSection>
        <Typography variant="h4" component="h1">{t('itemSearch:savedSearches')}</Typography>
      </TopSection>
      <Box p={3}>
        {status === 'loading' ? <Loading /> : null}
        {status === 'succeeded' ? <ItemSearchesList items={searches} handleDelete={handleDelete} handleSelect={handleSelect} showNoResultsMessage /> : null }
        {status === 'failed' && error ? <Alert severity="error">{t(`errors:${error}`)}</Alert> : null}
      </Box>
    </>
  );
};

export default SavedSearches;
